import { render, staticRenderFns } from "./SingleProfileView.vue?vue&type=template&id=4e08431c"
import script from "./SingleProfileView.vue?vue&type=script&lang=js"
export * from "./SingleProfileView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports